import styled from 'styled-components';

import SectionFrame from 'packages/smart-home-support/pages/homepage/components/SectionFrame';

import BREAK_POINTS from '@soluto-home-web/platform-common-ui/styling/media-queries';

const getMobileGradientOverlayForPage = (step: number): string => {
  if (step < 4) {
    return 'linear-gradient(180deg,rgba(27,27,27,0) 55%,rgba(4,4,2,0.75) 93.67%),';
  }

  return '';
};

const getDesktopGradientOverlayForPage = (step: number): string => {
  if (step < 4) {
    return 'linear-gradient(0deg, rgba(27, 27, 27, 0) 82%, rgba(4, 4, 2, 0.65) 93.67%),';
  }

  return '';
};

export default styled<any>(SectionFrame)`
  height: 220px;
  background-repeat: no-repeat;
  background: ${(props) => `${getMobileGradientOverlayForPage(props.step)} url(${props.image})`};
  background-size: cover;
  background-position: center;
  z-index: -1;
  display: ${(props) => (props.step > 3 ? 'none' : 'flex')};
  align-items: flex-end;
  background-position-y: ${(props) => {
    if (props.step === 2) {
      return '15%';
    }
    return '30%';
  }};

  @media ${(props) => (props.step === 5 ? BREAK_POINTS.tablet : BREAK_POINTS.desktop)} {
    width: 100%;
    background: ${(props) => `${getDesktopGradientOverlayForPage(props.step)} url(${props.image})`};
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: inherit;
    width: 50%;
    min-height: calc(100vh - 145px - 65px);
    background-position-x: center;
    display: block;
  }

  @media ${BREAK_POINTS.desktop} {
    ${(props) => (props.step === 5 ? 'min-height: 1010px;' : '')};
    display: block;
  }
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/components/SignupImageContainer.tsx